import { Currency } from '../../../common/enums/currency-enum';
import { ShareClassEnum } from '../../../common/enums/share-class-enum';
import { ProductCenterExhibit } from '../../product-center-table-wrapper/product-center-table-wrapper.model';

export const productCenterSearchMock: ProductCenterExhibit = {
  products: [
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 1',
        shareClass: ShareClassEnum.A,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SX',
        fundLink: '',
        sfdrClassification: 'ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.A}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 10,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
        },
        inceptionDate: '2021-01-01',
        morningstarMedalistRating: 'Gold',
      },

      productCode: 'FUND1',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 2',
        shareClass: ShareClassEnum.R,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SY',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Fixed Income',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.R}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 12,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 18,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 24,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 36,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 42,
            },
          ],
        },
        inceptionDate: '2021-02-01',
        morningstarMedalistRating: 'Bronze',
      },

      productCode: 'FUND2',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 3',
        shareClass: ShareClassEnum.F,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SZ',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Fixed Income',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.F}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 8,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 12,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 16,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 24,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 28,
            },
          ],
        },
        inceptionDate: '2021-03-01',
        morningstarMedalistRating: 'Bronze',
      },

      productCode: 'FUND3',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 4',
        shareClass: ShareClassEnum.I,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SA',
        fundLink: '',
        sfdrClassification: 'ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.I}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 40,
            },
          ],
        },
        inceptionDate: '2021-04-01',
        morningstarMedalistRating: 'Gold',
      },

      productCode: 'FUND4',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 5',
        shareClass: ShareClassEnum.R,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SB',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.R}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 10,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
        },
        inceptionDate: '2021-05-01',
        morningstarMedalistRating: 'Silver',
      },

      productCode: 'FUND5',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 6',
        shareClass: ShareClassEnum.I,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SC',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Fixed Income',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.I}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 8,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 12,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 16,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 24,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 28,
            },
          ],
        },
        inceptionDate: '2021-06-01',
        morningstarMedalistRating: 'Bronze',
      },

      productCode: 'FUND6',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 7',
        shareClass: ShareClassEnum.R,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SD',
        fundLink: '',
        sfdrClassification: 'ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.R}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 40,
            },
          ],
        },
        inceptionDate: '2021-07-01',
        morningstarMedalistRating: 'Gold',
      },

      productCode: 'FUND7',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 8',
        shareClass: ShareClassEnum.A,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SE',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.A}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 10,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
        },
        inceptionDate: '2021-08-01',
        morningstarMedalistRating: 'Silver',
      },

      productCode: 'FUND8',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 9',
        shareClass: ShareClassEnum.INVESTOR,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SF',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Fixed Income',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.INVESTOR}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 8,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 12,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 16,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 24,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 28,
            },
          ],
        },
        inceptionDate: '2021-09-01',
        morningstarMedalistRating: 'Bronze',
      },

      productCode: 'FUND9',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 10',
        shareClass: ShareClassEnum.F,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SG',
        fundLink: '',
        sfdrClassification: 'ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.F}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 40,
            },
          ],
        },
        inceptionDate: '2021-10-01',
        morningstarMedalistRating: 'Gold',
      },

      productCode: 'FUND10',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 11',
        shareClass: ShareClassEnum.I,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SH',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.I}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 10,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
        },
        inceptionDate: '2021-11-01',
        morningstarMedalistRating: 'Silver',
      },

      productCode: 'FUND11',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 12',
        shareClass: ShareClassEnum.RETIREMENTA,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SI',
        fundLink: '',
        sfdrClassification: 'Non-ESG',
        investmentStrategiesAssetClassName: 'Fixed Income',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.RETIREMENTA}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 8,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 12,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 16,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 24,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 28,
            },
          ],
        },
        inceptionDate: '2021-12-01',
        morningstarMedalistRating: 'Bronze',
      },

      productCode: 'FUND12',
      parentProductCode: '',
      disclaimers: [],
    },
    {
      productName: {
        vehicleTypeName: 'Australian Unit Trust',
        fundName: 'Fund 13',
        shareClass: ShareClassEnum.F,
        baseCurrencyName: Currency.USD,
        isin: '',
        apir: 'UTP262SJ',
        fundLink: '',
        sfdrClassification: 'ESG',
        investmentStrategiesAssetClassName: 'Equity',
        investmentStrategiesRegionName: 'Global',
        shareClassTerm: `Class ${ShareClassEnum.F}`,
      },
      performance: {
        performanceAsOfDate: '',
        fundReturns: {
          yearToDate: [
            {
              feeType: 'Gross',
              value: 15,
            },
          ],
          oneYear: [
            {
              feeType: 'Gross',
              value: 20,
            },
          ],
          threeYears: [
            {
              feeType: 'Gross',
              value: 25,
            },
          ],
          fiveYears: [
            {
              feeType: 'Gross',
              value: 30,
            },
          ],
          tenYears: [
            {
              feeType: 'Gross',
              value: 35,
            },
          ],
          sinceInception: [
            {
              feeType: 'Gross',
              value: 40,
            },
          ],
        },
        inceptionDate: '2022-01-01',
        morningstarMedalistRating: 'Gold',
      },

      productCode: 'FUND13',
      parentProductCode: '',
      disclaimers: [],
    },
  ],
  disclaimers: [],
};
